import template from './invoice-create-travel.html';
import controller from './invoice-create-travel.controller';

let invoiceCreateTravelComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default invoiceCreateTravelComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create-travel/invoice-create-travel.component.js